import React from 'react'
import { Translation } from 'react-i18next'
import { Field, WatchField } from '../../form'
import mobileView from '../../utils/mobile.utils'

const Consent = ({ classes, control, invoiceItemType, disabled }) => {
  return (
    <Translation>
      {(t) => {
        return (
          <div
            style={{
              paddingLeft: '21px'
            }}
          >
            <Field
              name="consent"
              inputType="checkbox"
              className={classes.checkbox}
              label={t('warnboard.confirm1') + '*'}
              control={control}
              disabled={disabled}
              errorStyle={{
                fontSize: '12px'
              }}
            ></Field>
            <WatchField control={control} fields="consent">
              {(watch) => (
                <div
                  className={watch.consent === true ? 'visible' : 'invisible'}
                  style={{
                    marginRight: mobileView ? '10px' : '230px',
                    color: disabled ? 'gray' : 'inherit'
                  }}
                >
                  <p>
                    {invoiceItemType === 'allowance'
                      ? t('warnboard.consent')
                      : t('warnboard.consent2')}
                    <a
                      href="https://www.vero.fi/syventavat-vero-ohjeet/ohje-hakusivu/110037/laskutuspalveluyritysten-maksamat-matkakustannusten-korvaukset2/"
                      target="_blank"
                      style={{
                        color: disabled ? 'gray' : 'inherit'
                      }}
                    >
                      {t('warnboard.here')}
                    </a>
                  </p>
                </div>
              )}
            </WatchField>
          </div>
        )
      }}
    </Translation>
  )
}

export default Consent
